import { TableComment } from "../../../../general/src/TableComment";
import { CurrentDispatchStops } from "../CurrentDispatchStops";
import { TableEquipmentAlerts } from "../TableEquipmentAlerts";
import { TableEquipmentIssued } from "../TableEquipmentIssued";
import { Button, CityState, DataHeader, DataSource, HorizontalSpacer, Label, Layout, Panel, Switch, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTrailer extends Layout {
    buttonLocateTrailer: Button;
    buttonOpenClassic: Button;
    buttonTrailerUsers: Button;
    citystateCityIdSearch: CityState;
    horizontalspacer1: HorizontalSpacer;
    labelMovementDistance: Label;
    labelMovementDistanceCaption: Label;
    labelMovementDistanceUm: Label;
    labelNoDispatchInfo: Label;
    labelOrder: Label;
    labelOrderId: Label;
    labelPreassignment: Label;
    labelPreassignmentCaption: Label;
    labelTempRange: Label;
    layoutCurrentDispatchStops: CurrentDispatchStops;
    layoutEquipmentIssued: TableEquipmentIssued;
    layoutImageTable: Layout;
    layoutTableComment: TableComment;
    layoutTableEquipmentAlerts: TableEquipmentAlerts;
    panelAdditionalInfo: Panel;
    panelCurrentDispatchHeader: Panel;
    panelCurrentDispatchSearch: Panel;
    panelDataHeader: DataHeader;
    panelDates: Panel;
    panelDimensions: Panel;
    panelDriver2: Panel;
    panelDriverOne: Panel;
    panelGeneralSide: Panel;
    panelMaintenanceInfo: Panel;
    panelMoveDistance: Panel;
    panelOrder: Panel;
    panelPayee: Panel;
    panelPreassignment: Panel;
    panelSearchContent: Panel;
    panelStopDetailsSearch: Panel;
    panelTare: Panel;
    panelTemperature: Panel;
    panelTrailerInfo: Panel;
    panelTrailerValue: Panel;
    sourceAgencyLink: DataSource;
    sourceComments: DataSource;
    sourceEquipmentIssued: DataSource;
    sourceTrailer: DataSource;
    sourceUnitMessage: DataSource;
    switchIsActive: Switch;
    tabComments: Tab;
    tabDispatch: Tab;
    tabEquipAlerts: Tab;
    tabEquipment: Tab;
    tabGeneral: Tab;
    tabImage: Tab;
    tabMaintenance: Tab;
    tabsetTrailer: Tabset;
    textDolly1Id: Textbox;
    textDolly2Id: Textbox;
    textDriverId: Textbox;
    textId: Textbox;
    textTractorId: Textbox;
    textTrailer1Id: Textbox;
    textTrailer2Id: Textbox;
    textTrailer3Id: Textbox;
    textboxActualArrivalSearch: Textbox;
    textboxActualDepartureSearch: Textbox;
    textboxAddressSearch: Textbox;
    textboxAxles: Textbox;
    textboxDisconnectDate: Textbox;
    textboxDollarValue: Textbox;
    textboxDoorHeight: Textbox;
    textboxDriver2Id: Textbox;
    textboxDriver2LastHomeDate: Textbox;
    textboxDriver2NextHomeDate: Textbox;
    textboxDriver2PtaDate: Textbox;
    textboxDriverLastHomeDate: Textbox;
    textboxDriverNextHomeDate: Textbox;
    textboxDriverPtaDate: Textbox;
    textboxFeatures: Textbox;
    textboxFloorSpace: Textbox;
    textboxGrossVehWeight: Textbox;
    textboxHeight: Textbox;
    textboxInserviceDate: Textbox;
    textboxInspectionDate: Textbox;
    textboxIsActive: Textbox;
    textboxLastLocation: Textbox;
    textboxLengthOf: Textbox;
    textboxLicenseNo: Textbox;
    textboxLicenseState: Textbox;
    textboxLocationNameSearch: Textbox;
    textboxMaintenanceDate: Textbox;
    textboxMake: Textbox;
    textboxMaxTemp: Textbox;
    textboxMessageSendDate: Textbox;
    textboxMinTemp: Textbox;
    textboxModelYear: Textbox;
    textboxOdometer: Textbox;
    textboxOdometerUpdateDate: Textbox;
    textboxOutserviceDate: Textbox;
    textboxOwner: Textbox;
    textboxOwnership: Textbox;
    textboxPallets: Textbox;
    textboxPlanningComment: Textbox;
    textboxPromiseDate: Textbox;
    textboxPurchaseDate: Textbox;
    textboxReeferId: Textbox;
    textboxSerialNumber: Textbox;
    textboxTagExpireDate: Textbox;
    textboxTrailerBatteryStatus: Textbox;
    textboxTrailerGroup: Textbox;
    textboxTrailerType: Textbox;
    textboxValueCurrencyType: Textbox;
    textboxVolume: Textbox;
    textboxWeight: Textbox;
    textboxWeightUm: Textbox;
    textboxWidth: Textbox;
    textboxWorkOrder: Textbox;
    textboxWorkOrderStatus: Textbox;
}
